
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function CTA() {
  const { t } = useTranslation();
  
  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-700 text-white">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          {t('Ready to Start Your Journey?')}
        </h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
          {t('Join our unique English learning experience through action sports')}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button 
            variant="secondary" 
            size="lg"
            className="bg-white text-blue-600 hover:bg-gray-100 whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            {t('Start Free Trial')}
          </Button>
          
          <a
            href="https://www.instagram.com/rampupenglish?igsh=NG9vZTBwY3F2bGw1&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center px-8 py-4 border-2 border-white text-white hover:bg-white hover:text-blue-600 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-instagram-line mr-2 text-xl"></i>
            Instagramをフォロー
          </a>
        </div>
        
        <p className="text-sm mt-6 opacity-75">
          {t('No credit card required • Cancel anytime')}
        </p>
      </div>
    </section>
  );
}
